export default __webpack_public_path__ + "5fe1b2d3e2ed97c3e164fe9339c306ec.png";